
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from './External.module.css'
import { PermmisionPostsTypeEnumText } from "../../../../lms-shared/models/PermmisionPostsTypeEnum";

const External = ({ dataPost }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const { uiData } = useSelector((state) => state.general);

    const [linkCopied, setLinkCopied] = useState(false);

    const clickCopyLink = () => {
        const url = `${window.location.origin}${uiData.baseName}${homeUrl}/${dataPost.shares[0].permissionMask === PermmisionPostsTypeEnumText.RunnerOnly
            ? 'projectRunner'
            : 'projectCodePublic'
            }/${dataPost?.id}`;

        navigator.clipboard.writeText(url);
        setLinkCopied(true);
    }

    useEffect(() => {
        if (linkCopied) {
            setTimeout(() => {
                setLinkCopied(false)
            }, 3000);
        }
    }, [linkCopied])

    return (
        uiData && (
            <div>
                <div className={classes.Title}>{dataPost.shares[0].permissionMask === PermmisionPostsTypeEnumText.RunnerOnly ? texts.copyLinkTitle : texts.copyLinkWithCodeTitle}</div>
                <div className={classes.ExternalWrapper}>
                    <div className={classes.Link}>
                        {`${window.location.origin}${uiData.baseName}${homeUrl}/${dataPost.shares[0].permissionMask === PermmisionPostsTypeEnumText.RunnerOnly
                            ? 'projectRunner'
                            : 'projectCodePublic'
                            }/${dataPost?.id}`}
                    </div>
                    <button className={classes.Button} onClick={clickCopyLink}>
                        {linkCopied ? texts.linkCopied : texts.copyLink}
                    </button>
                </div>
            </div>
        )
    );
}
export default External;